// src\data\products\base.tsx

const base = {
  promo: {
    promo: "30% OFF*",
    promoDesc: "Diskon hingga 30% khusus untuk pelanggan bisnis bukan perorangan",
  },

  freeDelivery: {
    freeDelivery: true,
    freeDeliveryDesc: `Gratis ongkir untuk area <a href="/coverage" title="Lihat area tercover" class="underline hover:text-purple">tercover</a>`,
  },

  rent: {
    rentDuration: { all: true },
    client: {
      government: true,
      company: true,
      school: true,
      event_organizer: true,
      startup: true,
      professional: true,
      individual: true,
    },
  },
}

export default base;